const HASH_ROUNDS = 64

export async function hashPassword(plainPassword: string): Promise<string> {
    const encoder = new TextEncoder()
    let data: ArrayBuffer = encoder.encode(plainPassword)

    for (let i = 0; i < HASH_ROUNDS; i++) {
        data = await crypto.subtle.digest('SHA-512', data)
    }

    const bytes = new Uint8Array(data)
    let binary = ''
    bytes.forEach((byte) => { binary += String.fromCharCode(byte) })
    return btoa(binary)
}